// :cow: Cosmose CONFIDENTIAL :iso:
export enum CampaignStatsReportTypeEnum {
  perWeek = 'PER_WEEK',
  perMarket = 'PER_MARKET',
  perDay = 'PER_DAY',
  perMedia = 'PER_MEDIA',
  perFormat = 'PER_FORMAT',
  perCreative = 'PER_CREATIVE',
  summary = 'SUMMARY',
  perMediaOffline = 'PER_MEDIA_OFFLINE',
  perMarketOffline = 'PER_MARKET_OFFLINE',
  perLocationCategoryOffline = 'PER_LOCATION_CATEGORY_OFFLINE',
  perLocationUnitOffline = 'PER_LOCATION_UNIT_OFFLINE',
}
